/* unplugin-vue-components disabled */import script from "./CouponDetailPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDetailPopup.vue?vue&type=script&setup=true&lang=js"

import "./CouponDetailPopup.vue?vue&type=style&index=0&id=6a0e050c&lang=scss"

const __exports__ = script;

export default __exports__